var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BasicTable',{ref:"table",attrs:{"table-name":_vm.tableName,"settingColumns":_vm.columns,"actions":_vm.actions,"settingTools":_vm.tools,"setting-apis":_vm.apis}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }